(function (window, document, undefined) {


  window.pShipping = {


    addListeners: () => {

      let open_btns = document.querySelectorAll('[data-action="open--p_shipping"]'),
          close_btns = document.querySelectorAll('[data-action="close--p_shipping"]'),
          toggle_btns = document.querySelectorAll('[data-action="toggle--p_shipping"]'),
          more_btn = document.querySelector('.p_shipping .box__c__description_btn'),
          ov = document.querySelector('.p_shipping__ov');
      
      if (open_btns.length) {
        [].forEach.call(open_btns, function(e) {
          e.addEventListener('click', () => {
            window.pShipping.open();
          });
        });
      }

      if (close_btns.length) {
        [].forEach.call(close_btns, function(e) {
          e.addEventListener('click', () => {
            window.pShipping.close();
          });
        });
      }

      if (toggle_btns.length) {
        [].forEach.call(toggle_btns, function(e) {
          e.addEventListener('click', () => {
            window.pShipping.toggle();
          });
        });
      }

      if (ov) {
        ov.addEventListener('click', () => {
          window.pShipping.close();
        });
      }

      if (more_btn) {
        more_btn.addEventListener('click', (e) => {
          window.animationSlideUp(e.target, 300);
          window.animationSlideDown(e.target.closest('.box__c').querySelector('.box__c__description'), 300);
        });
      }


    },


    open: () => {
      document.body.setAttribute('data-p-shipping', '1');
    },


    close: () => {
      document.body.setAttribute('data-p-shipping', '0');
    },


    toggle: () => {
      let current_value = document.body.getAttribute('data-p-shipping');
      if (current_value == '0') {
        window.pShipping.open();
      } else {
        window.pShipping.close();
      }
    },


    init: () => {
      
      window.pShipping.addListeners();

    }


  }


})(window, window.document);


window.pShipping.init();
